import { FormProvider } from 'react-hook-form';

import SettingsModal from '@components/shared/settingsModal';

import type { BillingProps } from './types/billing.props';

import BillingDatePicker from './billing-date-picker';
import { useBillingConfiguration } from './hooks/billing-configuration.hook';

export default function Billing({ onClose }: BillingProps) {
  const { formRef, handleCancel, handleOnClose, handleSubmit, methods, onOpen, onSubmit } = useBillingConfiguration({
    onClose,
  });

  return (
    <SettingsModal
      formRef={formRef}
      header="Billing Report"
      isOpen
      onCancel={handleCancel}
      onClose={handleOnClose}
      onOpen={onOpen}
      showDefaultButtons={false}>
      <FormProvider {...methods}>
        <form
          noValidate
          onSubmit={handleSubmit(onSubmit)}
          ref={formRef}>
          <BillingDatePicker />
        </form>
      </FormProvider>
    </SettingsModal>
  );
}
